import { Loader } from '@traceair/tds';
import { AbstractFileIcon } from '../../../../../../images/components/AbstractFileIcon';
import { GcpRequestFileType } from '../gcpRequestFileType';
import { declense } from '../../../../../../libs/declense';
import { CloseIcon, DeleteIcon } from '@traceair/webapp-icons';
import { GcpRequestUploadFile } from '../../../../../../store/uploadStore';
import { getGcpUploadBytes } from './getGcpUploadBytes';

const formatTextUploadProgress = (uploadedBytes: number, totalBytes: number) => {
  const KB = 1024;
  const MB = KB * 1024;

  const format = (bytes: number): string => {
    if (bytes >= MB) {
      return (bytes / MB).toFixed(1) + ' MB';
    } else {
      return Math.round(bytes / KB) + ' KB';
    }
  };

  return `${format(uploadedBytes)} / ${format(totalBytes)}`;
};

export const getGcpProgressUiElements = (
  type: GcpRequestFileType,
  files: string[],
  uploads: GcpRequestUploadFile[],
) => {
  const incompleteUploadCount = uploads.filter(({ isDone }) => !isDone).length;
  const isDone = !incompleteUploadCount;

  const icon = incompleteUploadCount ? <Loader /> : <AbstractFileIcon />;

  const total = files.length + incompleteUploadCount;
  let title: string;
  if (type === GcpRequestFileType.Photo) {
    title = incompleteUploadCount ? `${files.length} / ${declense(total, 'photo', 'photos')}` : 'Photos uploaded';
  } else {
    title = incompleteUploadCount ? `${files.length} / ${declense(total, 'file', 'files')}` : 'Files uploaded';
  }

  const { uploadedBytes, totalBytes } = getGcpUploadBytes(uploads);

  let note: string;
  if (type === GcpRequestFileType.Photo) {
    note = isDone ? declense(total, 'photo', 'photos') : formatTextUploadProgress(uploadedBytes, totalBytes);
  } else {
    note = isDone ? declense(total, 'file', 'files') : formatTextUploadProgress(uploadedBytes, totalBytes);
  }

  const removeIcon = uploads.some(({ isDone }) => !isDone) ? <CloseIcon /> : <DeleteIcon />;

  const progress = totalBytes ? (uploadedBytes / totalBytes) * 100 : 100;

  return {
    icon,
    title,
    note,
    removeIcon,
    progress,
    isDone: !incompleteUploadCount,
  };
};
